var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 67,
    viewBox: "0 0 53 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.755 28.674c3.485 2.383 3.485 7.524 0 9.907L11.386 64.126C7.404 66.849 2 63.997 2 59.174V8.08C2 3.257 7.404.405 11.386 3.128l37.369 25.546z",
    stroke: "#fff",
    strokeWidth: 3
  })));
}
SvgPlayIcon.displayName = 'PlayIcon';
export default SvgPlayIcon;